/**
 * Route for `hubspot-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { HubspotIntegrationPage } from "../features/hubspot-integration/HubspotIntegrationPage";

export const hubspotIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/hubspot-integration",
	component: HubspotIntegrationPage,
});

export default hubspotIntegrationRoute;
